module.exports = __webpack_public_path__ + "img/revenue.c3d3dd6.png";